import React from 'react';
import { i18n } from '../../i18n/translate.js';
import { DashboardCard } from '../DashboardCard/component.js';

var QuickActionsCard = function QuickActionsCard(_ref) {
  var _ref$quickActions = _ref.quickActions,
      quickActions = _ref$quickActions === void 0 ? [] : _ref$quickActions,
      height = _ref.height;

  var getActionBtnConfig = function getActionBtnConfig(quickAction) {
    var _quickAction$title;

    return [{
      label: quickAction.urlText,
      style: 'link',
      action: function action() {
        window.open(quickAction.url, quickAction.openInNewTab ? '_blank' : '_self', quickAction.openInNewTab ? 'noopener,noreferrer' : '');
      },
      data: {
        action: "action-dash-".concat((_quickAction$title = quickAction.title) === null || _quickAction$title === void 0 ? void 0 : _quickAction$title.toLowerCase()),
        objectType: 'quick_action'
      }
    }];
  };

  var visibleActions = quickActions.filter(function (action) {
    return !action.hidden;
  });
  return /*#__PURE__*/React.createElement(DashboardCard, {
    type: "quick-actions",
    title: i18n.t('Quick Actions'),
    items: visibleActions,
    height: height,
    emptyComponent: /*#__PURE__*/React.createElement("div", null, i18n.t('There are no quick actions available.')),
    getItemCardProps: function getItemCardProps(quickAction) {
      return {
        title: quickAction.title,
        titleIcon: quickAction.icon,
        description: quickAction.description,
        buttonConfig: getActionBtnConfig(quickAction)
      };
    }
  });
};

QuickActionsCard.displayName = "QuickActionsCard";
export { QuickActionsCard };